<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Create Invoice/Payment Order</p>
      </header>
      <section class="modal-card-body" style="height: 300px;">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Type</label>
              <select class="select is-fullwidth" v-model="type" name="type" id="type" @change="changeType()">
                <option value=''>Select a type</option>
                <option value='1' v-if="financial.invoice_financials === null">Invoice</option>
                <option value='2' v-if="financial.payment_financials === null">Payment</option>
              </select>
            </p>
          </div>
          <div class="control is-grouped" v-show="parseInt(type) === 1">
            <p class="control is-expanded">
              <label class="label">Customer</label>
              <v-select v-model="customer" :options="getCustomers()" class="is-fullwidth" max-height="200px"></v-select>
            </p>
          </div>
          <p class="control" v-show="parseInt(type) === 2">
            <label class="label">Supplier Type</label>
            <select class="select is-fullwidth" v-model="supplierType" name="supplierType" id="supplierType" @change="changeSupplierType()">
              <option value="0"></option>
              <option value="1">Providers</option>
              <option value="2">Hotels</option>
              <option value="3">Chains</option>
              <option value="4">Custom</option>
            </select>
          </p>
          <template v-if="parseInt(supplierType) === 1">
            <p class="control">
              <p class="control">
                <label class="label">Providers</label>
                <v-select
                  @search="getProviders"
                  :options="providers"
                  placeholder="Search a Provider"
                  label="name"
                  max-height="200px"
                  v-model="provider"
                >
                </v-select>
              </p>
            </p>
          </template>
          <template v-if="parseInt(supplierType) === 2">
            <p class="control">
              <p class="control">
                <label class="label">Hotel</label>
                <input class="input is-disabled" name="hotel" id="hotel" type="text" placeholder="" v-model="hotel.name">
              </p>
            </p>
          </template>
          <template v-if="parseInt(supplierType) === 3">
            <p class="control">
              <p class="control">
                <label class="label">Chain</label>
                <v-select
                  @search="getChains"
                  :options="chains"
                  placeholder="Search a Chain"
                  label="name"
                  max-height="200px"
                  v-model="chain"
                >
                </v-select>
              </p>
            </p>
          </template>
          <div class="control is-grouped" v-show="type !== ''">
            <p class="control">
              <label class="label">Payment Deadline</label>
              <datepicker ref="deadline"></datepicker>
            </p>
            <p class="control is-expanded">
              <label class="label">Total</label>
              <input class="input is-disabled" name="total" id="total" type="text" placeholder="" v-model="total">
            </p>
            <p class="control is-expanded">
              <label class="label">Currency</label>
              <select class="select is-fullwidth is-disabled" v-model="currency" name="currency" id="currency">
                <option value="BRL">BRL</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="AUD">AUD</option>
                <option value="CAD">CAD</option>
                <option value="MXN">MXN</option>
                <option value="GBP">GBP</option>
                <option value="ARS">ARS</option>
                <option value="ZAR">ZAR</option>
                <option value="THB">THB</option>
              </select>
            </p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || total <= 0 || type === '', 'is-loading': inProgress}" @click="create()">Create</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import _ from 'lodash'
  export default {
    props: {
      context: {
        type: Object
      },
      financial: {
        type: Object,
        required: true
      },
      hotel: {
        type: Object,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        total: 0,
        type: '',
        deadline: '',
        currency: 'BRL',
        customer: null,
        chain: {
          id: null,
          name: ''
        },
        provider: {
          id: null,
          name: ''
        },
        supplierType: 0,
        supplier: null,
        bases: [],
        agencies: [],
        providers: [],
        hotels: [],
        chains: [],
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      changeType () {
        if (parseInt(this.type) !== 0) {
          if (parseInt(this.type) === 1) {
            this.loadBases()
            this.loadAgencies()
            this.total = this.financial.gross_price
            this.currency = this.financial.gross_currency
          } else {
            this.total = this.financial.net_price
            this.currency = this.financial.net_currency
          }

          this.error = ''
        }
      },
      changeSupplierType () {
        if (parseInt(this.supplierTypetype) !== 0) {
          this.error = ''
        }
      },
      loadBases () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/bases/all').then((response) => {
          this.bases = response.body
        }, (response) => {
        })
      },
      loadAgencies () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/agencies/all').then((response) => {
          this.agencies = response.body
        }, (response) => {

        })
      },
      getCustomers () {
        let customers = []
        customers.push({label: 'All', value: ''})
        for (var i = 0; i < this.agencies.length; i++) {
          customers.push({label: this.agencies[i].name, value: this.agencies[i].id, type: 'agency'})
        }
        for (var x = 0; x < this.bases.length; x++) {
          customers.push({label: this.bases[x].name + ' (base)', value: this.bases[x].id, type: 'base'})
        }
        customers.sort(function (a, b) {
          if (a.label < b.label) {
            return -1
          }
          if (a.label > b.label) {
            return 1
          }
          return 0
        })
        return customers
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      create () {
        this.inProgress = true
        this.error = ''
        this.deadline = this.$refs.deadline.datepicker.input.value
        if (window.confirm('Are you sure you want to create ' + (parseInt(this.type) === 1 ? 'invoice' : 'payment'))) {
          if (parseInt(this.type) === 1) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/invoice/direct', {financial_id: this.financial.id, customer: this.customer, currency: this.currency, total: this.total, deadline: this.deadline}).then((response) => {
              this.inProgress = false
              this.close(false, 'Financial #' + this.financial.id + ' has been Added from invoice #' + response.body.id)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/direct', {financial_id: this.financial.id, supplier: this.supplier, supplier_type: this.supplierType, currency: this.currency, total: this.total, deadline: this.deadline, provider: this.provider.id, chain: this.chain.id, hotel: this.hotel.hotel_id}).then((response) => {
              this.inProgress = false
              this.close(false, 'Financial #' + this.financial.id + ' has been Added from payment #' + response.body.id)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        } else {
          this.inProgress = false
        }
      },
      getProviders: _.debounce(function (search, loading) {
        if (search.length) {
          loading(true)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/all', { params: {'query': search}
          }).then(response => {
            this.providers = response.body
            loading(false)
          })
        }
      }, 500),
      getChains: _.debounce(function (search, loading) {
        if (search.length) {
          loading(true)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/chains/all', { params: {'query': search}
          }).then(response => {
            this.chains = response.body
            loading(false)
          })
        }
      }, 500),
      getHotels: _.debounce(function (search, loading) {
        if (search.length) {
          loading(true)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/hotels/search', { params: {'query': search}
          }).then(response => {
            this.hotels = response.body
            loading(false)
          })
        }
      }, 500)
    },
    components: {
      Datepicker,
      vSelect
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// InvoicePaymentDirect.vue?586b8032